function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.117 21.946h14.689c1.757 0 2.777-1.02 2.777-2.969V8.915a2.661 2.661 0 0 0-3-2.969H6.9c-1.758 0-2.777 1.011-2.777 2.969v10.063a2.661 2.661 0 0 0 2.994 2.968zm6.211-7.686L6.7 7.7a2.056 2.056 0 0 1 .428-.046h14.45a1.711 1.711 0 0 1 .446.055L15.4 14.26a1.5 1.5 0 0 1-1.038.537 1.537 1.537 0 0 1-1.034-.537zm-7.5-5.218 4.954 4.872-4.954 4.9zm12.13 4.872L22.88 9.07v9.73zM7.126 20.225a2.334 2.334 0 0 1-.455-.045l5.218-5.172.492.492a2.777 2.777 0 0 0 1.985.92 2.759 2.759 0 0 0 1.976-.92l.5-.492 5.209 5.163a1.93 1.93 0 0 1-.474.055z",
  transform: "translate(-2.121 -1.947)"
});

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.287f007c.svg";
export { ForwardRef as ReactComponent };